<template>
  <section class="custom-wrapper">
    <!-- Listing Actions -->
    <div class="table-responsive">
      <div class="row custom-row">
        <div class="col-3">
          <button class="btn btn-primary btn-small mb-2" @click="addMakeMatrix">Add</button>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-4">
              <z-select v-model="filter" label="Make" :options="vehicles" :inline="true" @change="refreshList" />
            </div>
            <div class="col">
              <div class="custom-show-checkbox">
                <input v-model="showInactive" type="checkbox" class="custom-checkbox me-2" @change="refreshList" />
                <span>Show Inactive?</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Listing -->
      <div v-show="loading?.adasmakematrices" class="listingWrapper">
        <div class="custom-spinner"><i class="fas fa-spinner fa-spin"></i></div>
      </div>
      <div v-show="!loading?.adasmakematrices" class="listingWrapper">
        <z-table
          v-model="adasmakematrices"
          class="table table-bordered table-striped"
          :is-single-row-detail="true"
          sort-on="sort"
          sort-dir="asc"
          :columns="tableColumnsName"
          :is-header-fixed="true"
          @sort="setOrder"
        >
          <template #tbody="props">
            <td class="custom-column-60">
              <a href="#" @click="editMakeMatrix(props.row)">edit</a>
            </td>
            <td>{{ props.row.vehicleMake }}</td>
            <td>{{ props.row.vehicleModel }}</td>
            <td>{{ props.row.system }}</td>
            <td>{{ props.row.location }}</td>
            <td class="custom-column-80 text-center">{{ props.row.yearStart }}</td>
            <td class="custom-column-80 text-center">{{ props.row.yearEnd }}</td>
            <td>{{ props.row.source }}</td>
            <td class="custom-column-60-center">
              {{ props.row.isInactive ? 'Y' : '' }}
            </td>
          </template>
          <template #detail="props">
            <matrix-make-lookups :matrix="props.row" />
          </template>
          <template #empty> Nothing found! </template>
        </z-table>
      </div>
    </div>
    <!-- Dialogs -->
    <dialog-matrix v-model="actionMatrix" @closing="closeModal" @saved="savedMakeMatrix" />
    <confirm-delete
      v-model="actionDelete"
      :confirm-title="confirmTitle"
      :confirm-action="confirmAction"
      :confirm-question="confirmQuestion"
      @closing="closeModal"
      @proceed="performDelete"
    />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZTable from '@/components/utilities/elements/Table.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import DialogMatrix from './dialog-make-matrix.vue'
import MatrixMakeLookups from './matrix-make-lookups.vue'
export default {
  name: 'MatrixMakes',
  components: {
    ZTable,
    ZSelect,
    ConfirmDelete,
    DialogMatrix,
    MatrixMakeLookups
  },
  props: {
    value: Object
  },
  data() {
    return {
      actionMatrix: null,
      actionDelete: null,
      confirmTitle: 'Delete this Make Matrix?',
      confirmAction: 'Delete',
      confirmQuestion: 'Are you sure you wish to Delete this Make Matrix?',
      showInactive: false,
      filter: '-9999',
      orderBy: 'vehicleMake',
      sortBy: 'asc'
    }
  },
  async mounted() {
    this.filter = '-9999'
    this.orderBy = 'vehicleMake'
    this.sortBy = 'asc'
    this.showInactive = false
    if (this.value) {
      if (this.value.vehicleMake) {
        this.filter = this.value.vehicleMake
      }
    }
    await this.getList()
  },
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'lookups', 'adasmatrix', 'adasmakematrices']),
    tableColumnsName() {
      return [
        {
          field: 'adasChecklistMatrixVehicle',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'vehicleMake',
          label: 'Make',
          sortable: true
        },
        {
          field: 'vehicleModel',
          label: 'Model',
          sortable: false
        },
        {
          field: 'system',
          label: 'System',
          sortable: true
        },
        {
          field: 'location',
          label: 'Location',
          sortable: true
        },
        {
          field: 'yearStart',
          label: 'Yr Start',
          sortable: false,
          class: 'custom-column-80 text-center'
        },
        {
          field: 'yearEnd',
          label: 'Yr End',
          sortable: false,
          class: 'custom-column-80 text-center'
        },
        {
          field: 'source',
          label: 'Type',
          sortable: true
        },
        {
          field: 'isInactive',
          label: 'Inactive?',
          sortable: false,
          class: 'custom-column-60-center'
        }
      ]
    },
    vehicles() {
      let _data = []
      _data.push({
        id: -9999,
        name: 'all',
        value: -9999
      })
      if (this.lookups['VehicleMake']) {
        this.lookups['VehicleMake'].forEach((element) => {
          _data.push(element)
        })
      }
      return _data
    },
    vehicleMake() {
      let _id = null
      if (this.value) {
        _id = this.value.vehicleMake
      }
      return _id
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, [
      'getKeywords',
      'getAdasMakeMatrices',
      'getAdasMakeMatrix',
      'initMakeMatrix',
      'updateAdasMatrixItem',
      'updateAdasMakeMatrix',
      'deleteAdasMakeMatrix',
      'getAdasMakeMatrixCategories'
    ]),
    closeModal() {
      this.actionMatrix = null
      this.actionDelete = null
    },
    refreshList() {
      this.getList()
    },
    setOrder(column, sortBy) {
      this.orderBy = column.field
      this.sortBy = sortBy
      this.getList()
    },
    async getList() {
      let options = {
        id: this.adasmatrix.adasChecklistMatrix,
        orderBy: this.orderBy,
        sortBy: this.sortBy,
        filter: this.filter === '-9999' ? null : this.filter,
        status: this.showInactive ? 'Inactive' : ''
      }
      console.log('Refreshing ADAS Make matrix', options)
      await this.getAdasMakeMatrices(options)
    },
    async addMakeMatrix() {
      this.initMakeMatrix()
      this.updateAdasMakeMatrix({
        name: 'adasChecklistMatrix',
        value: this.adasmatrix.adasChecklistMatrix
      })
      this.actionMatrix = {
        type: 'ADD',
        subtitle: this.adasmatrix.matrixItem
      }
    },
    async editMakeMatrix(matrix) {
      console.log('Editing Make Matrix', matrix)
      await this.getKeywords({
        keys: ['CCCKeywordsLine', 'CCCKeywordsLocation', 'CCCKeywordsSublet', 'AddlOperation'],
        vehicleMake: matrix.vehicleMakeId
      })
      await this.getAdasMakeMatrixCategories()
      this.getAdasMakeMatrix(matrix.adasChecklistMatrixVehicle)
      this.actionMatrix = {
        type: 'EDIT',
        subtitle: this.adasmatrix.matrixItem
      }
    },
    async savedMakeMatrix() {
      await this.getList()
      this.closeModal()
    },
    confirmDelete(matrix) {
      this.actionDelete = matrix
    },
    async performDelete(matrix) {
      this.actionDelete = null
      console.log('Deleting Make Matrix', matrix)
      await this.deleteAdasMakeMatrix(matrix.adasChecklistMatrixVehicle)
      await this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
}
.custom-row {
  margin: 0 !important;
  width: 100%;
}
.custom-spinner {
  width: 100%;
  text-align: center;
  font-size: 1.1em;
}
.listingWrapper {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 430px;
  width: 100%;
}
.custom-show-checkbox {
  position: relative;
  top: 5px;
}
</style>
